import moment from "moment";

export const  getYearMonth = (override = {}) =>  {
  const now = moment();
  return {
    year: override.year ? override.year : parseInt(now.format('YYYY')),
    month: override.month ? override.month : parseInt(now.format('M'))
  };
}